import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedDate, FormattedMessage } from 'react-intl';

import FormatProductName from 'Helpers/Format/FormatProductName';
import 'Components/Order/OrdersItemCard.scss';

export default function OrdersItemCard({ id, date, items, status, isGiftSender, itemsToShow }) {
  const [expandedState, setExpandedState] = useState(false);

  const updateState = (e) => {
    e.preventDefault();
    setExpandedState(!expandedState);
  };

  return (
    <div className="OrderItemsCard table-item">
      <Link to={`/orders/${id}`}>
        <div className="mobile-date d-md-none">
          <div>
            <span className="date-text">
              <FormattedMessage id="orders.view-date-text" defaultMessage="Order Date:" />
            </span>
            <FormattedDate value={date} year="numeric" month="short" day="2-digit" />
          </div>
          <div>
            <span className="date-text">
              <FormattedMessage id="orders.mobile-status" defaultMessage="Status:" />
            </span>
            {status}
          </div>
        </div>
        <div className="details-container">
          <div className="date-col d-none d-md-block">
            <FormattedDate value={date} year="numeric" month="short" day="2-digit" />
          </div>
          <div className="item-col">
            {!expandedState && items.slice(0, itemsToShow).map(item =>
              <p className="order-item-name" key={`${item.name}-${id}`}>{FormatProductName(item.name, item.type)}</p>,
            )}
            {expandedState && items.map(item =>
              <p className="order-item-name" key={`${item.name}-${id}`}>{FormatProductName(item.name, item.type)}</p>,
            )}
            {items.length > itemsToShow &&
              <button onClick={e => updateState(e)}>
                {expandedState ? 'Show Less' : 'Show More'}
              </button>
            }
          </div>
          <div className="d-none d-md-block status-col">
            {status}
          </div>
          <div className="d-none d-md-block action-col">
            <div className="action-link">
              {!isGiftSender && <FormattedMessage id="orders.view-orders" defaultMessage="View Order & Keys" />}
              {isGiftSender && <FormattedMessage id="orders.view-ordersmanagegifts" defaultMessage="View & Manage Gifted Order" />}
            </div>
          </div>
        </div>
        <div className="d-md-none mobile-view-btn">
          <div className="btn btn-link">
            {!isGiftSender && <FormattedMessage id="orders.view-orders" defaultMessage="View Order & Keys" />}
            {isGiftSender && <FormattedMessage id="orders.view-ordersmanagegifts" defaultMessage="View & Manage Gifted Order" />}
          </div>
        </div>
      </Link>
    </div>
  );
}

OrdersItemCard.propTypes = {
  id: PropTypes.string,
  date: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  status: PropTypes.string,
  isGiftSender: PropTypes.bool,
  itemsToShow: PropTypes.number,
};

OrdersItemCard.defaultProps = {
  id: '',
  date: '',
  items: [],
  status: '',
  isGiftSender: false,
  itemsToShow: 10,
};
